export const FOCUS_EDITOR_EVENT = 'focus-editor-event';

export const BLUR_EDITOR_EVENT = 'blur-editor-event';
